import React from 'react';
import { Compass, Plus, CheckCircle2 } from 'lucide-react';

import LinkButton from './LinkButton';
import css from './Hero.module.css';

const TRUST = ['Free to list', 'Stripe-backed payouts', 'No monthly fees'];

/**
 * Centered hero. This is the variant the Claude Design handoff was saved with
 * (hero: centered, headline: "experts", CTA emphasis: provider-first).
 */
const Hero = () => {
  return (
    <section className={css.hero}>
      <div className={css.inner}>
        <span className={css.eyebrow}>
          <span className={css.dot} />
          750+ providers, live across the US and Canada
        </span>

        <h1 className={css.headline}>
          Where event pros meet <span className={css.purple}>photo booth experts</span>.
        </h1>

        <p className={css.lede}>
          One account, both sides: post the events you can't cover, and win the ones you can.
          Compare live bids from 750+ providers across the US and Canada, all in one workflow.
        </p>

        <div className={css.ctas}>
          <LinkButton name="SearchPage" variant="secondary" large>
            <Compass />
            Find opportunities
          </LinkButton>
          <LinkButton name="NewListingPage" variant="ghost" large>
            <Plus />
            Post an event
          </LinkButton>
        </div>

        <ul className={css.trust}>
          {TRUST.map(item => (
            <li key={item} className={css.trustItem}>
              <CheckCircle2 className={css.trustIcon} />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Hero;
